import { Reducer } from "react";
import userTypes from "./userTypes";
import { parseJwt } from "utilities/sharedFunctions";

const INITIAL_STATE = {
  user: null,
  expireTime: 0,
  refreshToken: "",
  permissions: null,
};

const userReducer: Reducer<any, any> = (state = INITIAL_STATE, actions) => {
  switch (actions.type) {
    case userTypes.SET_USER:
      const temp = parseJwt(actions.payload.access_token);
      return {
        ...state,
        user: temp,
        expireTime: Math.ceil(Date.now() / 1000) + actions.payload.expires_in,
        refreshToken: actions.payload.refreshToken,
      };

    case userTypes.SET_PERMISSIONS:
      return {
        ...state,
        permissions: [...actions.payload],
      };
    case userTypes.LOGOUT_USER:
      return {
        ...state,
        user: null,
        expireTime: 0,
        refreshToken: "",
        permissions: null,
      };
    default:
      return state;
  }
};

export default userReducer;
